export const getIntFromId = (id: string): number =>
  Array.from(id.replace(/-/g, ""))
    .map(char => char.charCodeAt(0))
    .reduce((acc, next) => acc + next, 0);
